<template>
  <form @submit="onSubmit">
    <div
      class="tp-product-details-review-form-rating d-flex align-items-center"
    >
      <p>{{ $t("Your Rating") }} :</p>
      <div
        class="tp-product-details-review-form-rating-icon d-flex align-items-center"
      >
        <span v-for="i in rating" :key="i" @click="handleRating(i)"
          ><i class="fa-solid fa-star rating"></i
        ></span>
        <span v-for="i in 5 - rating" :key="i" @click="handleRating(rating + i)"
          ><i class="fa-regular fa-star rating"></i
        ></span>
        <!-- <span><i class="fa-solid fa-star"></i></span>
        <span><i class="fa-solid fa-star"></i></span>
        <span><i class="fa-solid fa-star"></i></span>
        <span><i class="fa-solid fa-star"></i></span> -->
      </div>
    </div>
    <div class="tp-product-details-review-input-wrapper">
      <div class="tp-product-details-review-input-box">
        <div class="tp-product-details-review-input">
          <Field name="content" v-slot="{ field }">
            <textarea
              v-bind="field"
              id="content"
              name="content"
              :placeholder="$t('Write your content here...')"
            ></textarea>
          </Field>
        </div>
        <div class="tp-product-details-review-input-title">
          <label for="content">{{ $t("Write Review") }}</label>
        </div>
        <err-content :msg="errors.content" />
      </div>
      <!-- <div class="tp-product-details-review-input-box">
        <div class="tp-product-details-review-input">
          <input
            name="name"
            id="name"
            type="text"
            placeholder="Shahnewaz Sakil"
            v-bind="name"
          />
        </div>
        <div class="tp-product-details-review-input-title">
          <label for="name">Your Name</label>
        </div>
        <err-content :msg="errors.name" />
      </div>
      <div class="tp-product-details-review-input-box">
        <div class="tp-product-details-review-input">
          <input
            name="email"
            id="email"
            type="email"
            placeholder="swift@mail.com"
            v-bind="email"
          />
        </div>
        <div class="tp-product-details-review-input-title">
          <label for="email">Your {{ $t("Email") }}</label>
        </div>
        <err-content :msg="errors.email" />
      </div> -->
    </div>
    <!-- <div class="tp-product-details-review-suggetions mb-20">
      <div class="tp-product-details-review-remeber">
        <input id="remeber" type="checkbox" />
        <label for="remeber"
          >Save my name, email, and website in this browser for the next time I
          comment.
        </label>
      </div>
    </div> -->
    <div class="tp-product-details-review-btn-wrapper">
      <button type="submit" class="tp-product-details-review-btn">
        {{ $t("Submit") }}
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm, Field } from "vee-validate";
import * as yup from "yup";
import { type IProduct } from "../../types/product-type";
import { useReviewStore } from "../../pinia/useReviewStore";
import { type NewReview } from "../../types/review-type";
import { storeToRefs } from "pinia";
import { useAuthStore } from "../../pinia/useAuthStore";

interface IFormValues {
  // name?: string | null;
  // email?: string | null;
  content?: string | null;
}
const { createReview } = useReviewStore();
const { errors, handleSubmit, defineInputBinds, resetForm } =
  useForm<IFormValues>({
    validationSchema: yup.object({
      // name: yup.string().required().label("Name"),
      // email: yup.string().required().email().label("Email"),
      content: yup.string().required().label("Review"),
    }),
  });
const props = defineProps<{ product: IProduct }>();
const onSubmit = handleSubmit(async (values) => {
  const { user } = storeToRefs(useAuthStore());
  let newReview = {
    content: values.content,
    name: user.value?.name,
    email: user.value?.email,
    rating: rating.value,
  } as NewReview;
  await createReview(newReview, props.product.id);
  resetForm();
  rating.value = 1;
});

const rating = ref<number>(1);
const handleRating = (index: number) => {
  rating.value = index;
};
const name = defineInputBinds("name");
const email = defineInputBinds("email");
</script>
<style>
.rating:hover {
  cursor: pointer;
}
</style>
